function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "finals"
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.68,232.75c11.26-13,55.63-79.86,70.63-127.47A75.42,75.42,0,1,0,5.18,94.76h0c.11.5.24,1,.36,1.53s.3,1.21.46,1.81C18.39,145.86,66.84,219.08,78.68,232.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M106.74,26.4H97.09l.36,24a8.76,8.76,0,0,1-8,8.19l-3.09-4.37H72l-3.09,4.37a8.76,8.76,0,0,1-8-8.19l.36-24H51.58c-18.2,49.51-16.2,97.39-16.2,97.39,0,5.83,4.55,4.92,4.55,4.92h78.46s4.55.91,4.55-4.92C122.94,123.79,124.94,75.91,106.74,26.4Zm-4.4,82.9a3.9,3.9,0,0,1-3.9,3.9h-39a3.9,3.9,0,0,1-3.9-3.9V83.5a3.91,3.91,0,0,1,3.9-3.9h39a3.91,3.91,0,0,1,3.9,3.9Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "75.77 106.31 84.94 106.31 94.53 96.38 94.53 86.45 94.3 86.45 75.77 106.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "88.82 86.45 72.75 86.45 62.82 96.73 62.82 106.31 70.3 106.31 88.82 86.45"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.78,232.14l1.89,1.64c1.48-1.72,3.43-4.22,5.78-7.42a594.7,594.7,0,0,0,33.81-53c12.63-22.18,24.87-46.78,31.53-67.91l-2.38-.75,2.34.88A77.91,77.91,0,1,0,0,77.91,78.57,78.57,0,0,0,1.83,94.69l2.45-.53,1.46-2h0L.33,88.22l1.49,6.49c.12.52.25,1,.37,1.55h0c.15.62.31,1.24.48,1.88v0c3.17,12.17,8.57,25.82,15.09,39.7a581.38,581.38,0,0,0,33,59.64c5.47,8.73,10.61,16.48,15,22.71s7.87,10.92,10.2,13.62L77.78,236l1.89-2.18-1.89-1.64,1.89-1.64c-1.4-1.61-3.43-4.22-5.88-7.58a603.91,603.91,0,0,1-35.63-56.46c-6.54-11.72-12.88-24-18.24-35.89A218.36,218.36,0,0,1,7.5,96.85v0c-.16-.57-.3-1.15-.45-1.75h0c-.12-.52-.25-1-.36-1.5l-2.43.56-1.47,2h0L8.12,100l-1.4-6.4a72.9,72.9,0,1,1,139.35,10.16l0,.06,0,.08c-7.38,23.46-22.16,52-36.48,76.19-7.16,12.1-14.21,23.13-20.15,31.92-3,4.4-5.68,8.24-8,11.37s-4.2,5.57-5.53,7.1l1.89,1.64,1.89-1.64Z"
})));

var SvgBallastBag = function SvgBallastBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 155.81 235.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBallastBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ballast-bag.c7c18b24.svg";
export { ForwardRef as ReactComponent };